/**
 * Custom error classes for the SDK
 */

export class YampaWidgetError extends Error {
  readonly code?: string;
  readonly cause?: Error;

  constructor(message: string, code?: string, cause?: Error) {
    super(message);
    this.code = code;
    this.cause = cause;
    this.name = "YampaWidgetError";
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
  }
}

export class BridgeError extends YampaWidgetError {
  constructor(message: string, code?: string, cause?: Error) {
    super(message, code, cause);
    this.name = "BridgeError";
  }
}

export class ValidationError extends YampaWidgetError {
  constructor(message: string, code?: string, cause?: Error) {
    super(message, code, cause);
    this.name = "ValidationError";
  }
}

export class TimeoutError extends YampaWidgetError {
  constructor(message: string, code?: string, cause?: Error) {
    super(message, code, cause);
    this.name = "TimeoutError";
  }
}

export class ConfigurationError extends YampaWidgetError {
  constructor(message: string, code?: string, cause?: Error) {
    super(message, code, cause);
    this.name = "ConfigurationError";
  }
}
